export default "__VITE_ASSET__5JGAuv16__"